export default "__VITE_ASSET__CtJIOg_A__"